import { ReactNode } from 'react';

interface InfoCalloutProps {
  position: 'left' | 'right';
  x: number;
  y: number;
  labelY?: number;
  title: string;
  value?: string;
  description?: string;
  color?: string;
  icon?: ReactNode;
}

export const InfoCallout = ({
  position,
  x,
  y,
  labelY,
  title,
  value,
  description,
  color = '#64748b',
}: InfoCalloutProps) => {
  const isLeft = position === 'left';
  const resolvedLabelY = labelY ?? y;
  const elbowX = isLeft ? x - 8 : x + 8;
  const lineEndX = isLeft ? x - 10 : x + 10;
  const textX = isLeft ? x - 15 : x + 15;
  const anchor = isLeft ? 'end' : 'start';

  return (
    <g>
      <polyline
        points={`${x},${y} ${elbowX},${resolvedLabelY} ${lineEndX},${resolvedLabelY}`}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeOpacity="0.7"
      />

      <circle cx={x} cy={y} r="3" fill={color} opacity="0.8" />
      <circle cx={lineEndX} cy={resolvedLabelY} r="2" fill={color} opacity="0.8" />

      <text
        x={textX}
        y={resolvedLabelY - 12}
        fontSize="13"
        fontWeight="600"
        fill="#1e293b"
        textAnchor={anchor}
      >
        {title}
      </text>

      {value && (
        <text
          x={textX}
          y={resolvedLabelY + 5}
          fontSize="15"
          fontWeight="700"
          fill={color}
          textAnchor={anchor}
        >
          {value}
        </text>
      )}

      {description && (
        <text
          x={textX}
          y={resolvedLabelY + 20}
          fontSize="10"
          fill="#64748b"
          textAnchor={anchor}
        >
          {description}
        </text>
      )}
    </g>
  );
};
